(function () {
  var fruits = ['🍋', '🍍', '🥥', '⚡'];
  var activeLayers = 0;
  var maxActiveLayers = 5;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function randomBetween(min, max) {
    return Math.random() * (max - min) + min;
  }

  function makeFruit(layer) {
    var fruit = document.createElement('span');
    var duration = randomBetween(2.8, 4.6);
    var drift = randomBetween(-18, 18);

    fruit.className = 'gigi-fruit-rain__piece';
    fruit.textContent = fruits[Math.floor(Math.random() * fruits.length)];
    fruit.style.left = randomBetween(-4, 100) + 'vw';
    fruit.style.setProperty('--gigi-fruit-size', randomBetween(2.4, 5.8) + 'rem');
    fruit.style.setProperty('--gigi-fruit-drift', drift + 'vw');
    fruit.style.setProperty('--gigi-fruit-spin', randomBetween(-1.4, 1.4) + 'turn');
    fruit.style.animationDuration = duration + 's';
    fruit.style.animationDelay = randomBetween(0, 1) + 's';

    layer.appendChild(fruit);
  }

  function rainFruit() {
    if (prefersReducedMotion()) return;
    if (activeLayers >= maxActiveLayers) return;

    activeLayers += 1;
    var layer = document.createElement('div');
    layer.className = 'gigi-fruit-rain';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);

    for (var index = 0; index < 90; index += 1) {
      makeFruit(layer);
    }

    window.setTimeout(function () {
      layer.remove();
      activeLayers = Math.max(0, activeLayers - 1);
    }, 5600);
  }

  document.addEventListener('click', function (event) {
    var logo = event.target.closest('.footer__social-logo');
    if (!logo) return;
    rainFruit();
  });
})();
